import React from 'react';

interface Team {
  id: string;
  name: string;
  organization_id: string;
  organization?: { id: string | number };
  created_at: string;
  updated_at: string;
}

interface TeamContextType {
  team: Team | null;
  setContext: (team: Team | null) => void;
}

const TeamContext = React.createContext<TeamContextType>({
  team: null,
  setContext: () => {}
});

export default TeamContext;
